import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/auth.store';

export function PendingPage() {
  const navigate = useNavigate();
  const officer = useAuth((s) => s.officer);
  const refreshMe = useAuth((s) => s.refreshMe);
  const logout = useAuth((s) => s.logout);

  // ทุก 15 วินาที refresh /me เพื่อรับสถานะ active เมื่อ admin approve แล้ว
  useEffect(() => {
    const t = setInterval(() => {
      refreshMe().catch(() => undefined);
    }, 15000);
    return () => clearInterval(t);
  }, [refreshMe]);

  useEffect(() => {
    if (officer?.status === 'active') navigate('/', { replace: true });
  }, [officer?.status, navigate]);

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center bg-white p-6 text-center">
      <div className="text-6xl">⏳</div>
      <h1 className="mt-4 text-2xl font-bold">รออนุมัติ</h1>
      <p className="mt-2 text-gray-600">
        บัญชีของคุณ{' '}
        <span className="font-medium">
          {officer?.firstName} {officer?.lastName}
        </span>{' '}
        ส่งคำขอเรียบร้อยแล้ว
        <br />
        กรุณารอผู้ดูแลระบบอนุมัติ
      </p>
      <button
        onClick={() => refreshMe().catch(() => undefined)}
        className="btn-secondary mt-8"
      >
        ตรวจสอบสถานะอีกครั้ง
      </button>
      <button onClick={logout} className="mt-3 text-sm text-gray-500 underline">
        ออกจากระบบ
      </button>
    </div>
  );
}
